import React, { useEffect } from "react";
//import SummaryCards from '../components/Dashboard/SummaryCards';
//import ChartsSection from '../components/Dashboard/ChartsSection';
import TaskManagement from "../components/TaskManagement/TaskManagement";
import TaskModal from "../components/modals/TaskModal";
import CommentsModal from "../components/modals/CommentsModal";
import AttachmentsModal from "../components/modals/AttachmentsModal";
import ActionCommentsModal from "../components/modals/ActionCommentsModal";
import DeadlineHistoryModal from "../components/modals/DeadlineHistoryModal";
import { useTaskManagement } from "../hooks/useTaskManagement";
import { useModalManager } from "../hooks/useModalManager";
import SummaryCards from "../components/Charts/SummaryCards";
import ChartsSection from "../components/Charts/ChartsSection";
//import ChartsSection from '../components/Dashboard/ChartsSection';
const Dashboard = () => {
  const { tasks, dashBoardSummary, filterTask, isLoading, refreshTasks } =
    useTaskManagement();
  const { modals, openModal, closeModal } = useModalManager();
  const user = JSON.parse(sessionStorage.getItem("user"));
  const roleName = user?.roleName || "";
  const userId = user?.userID || "";
  const userName = user?.userName;

  const priorityChart = {
    top: dashBoardSummary?.topTasks,
    high: dashBoardSummary?.highTasks,
    medium: dashBoardSummary?.mediumTasks,
    low: dashBoardSummary?.lowTaskss,
  };
  const columnChart = {
    workInProgress: dashBoardSummary?.workInProgress,
    onTime: dashBoardSummary?.onTime,
    slightDelay: dashBoardSummary?.slightDelay,
    significantDelay: dashBoardSummary?.significantDelay,
  };
  const timelineChart = {
    topTasksWeekly: dashBoardSummary?.topTasksWeekly,
    mediumTasksWeekly: dashBoardSummary?.mediumTasksWeekly,
    highTasksWeekly: dashBoardSummary?.highTasksWeekly,
    lowTasksWeekly: dashBoardSummary?.lowTasksWeekly,
  };
  useEffect(() => {
    console.log(tasks);
  }, [tasks]);

  return (
    <div className="main-content">
      <div className="container">
        <SummaryCards
          totalTasks={dashBoardSummary?.totalTasks}
          topTasks={dashBoardSummary?.topTasks}
          highTasks={dashBoardSummary?.highTasks}
          mediumTasks={dashBoardSummary?.mediumTasks}
          lowTasks={dashBoardSummary?.lowTaskss}
          filterTask={filterTask}
          // totalTasks={tasks.length}
          // completedTasks={tasks.filter(t => t.status === 'Completed').length}
          // delayedTasks={tasks.filter(t => t.status.includes('Delay')).length}
        />

        <ChartsSection
          columnChartConfig={columnChart}
          priorityChartConfig={priorityChart}
          timelineChartConfig={timelineChart}
          tasks={tasks}
        />

        <TaskManagement
          tasks={tasks}
          isLoading={isLoading}
          refreshTasks={refreshTasks}
          openModal={openModal}
          roleName={roleName} // 🔁 Pass roleName here
          userId={userId}
          userName={userName}
        />

        <TaskModal
          show={modals.task.show}
          onHide={() => closeModal("task")}
          refreshTasks={refreshTasks}
          roleName={roleName} // 🔁 Pass roleName to TaskModal
        />
      </div>
    </div>
  );
};

export default Dashboard;
